enum IntlTelFormatEnum {
  "E164" = 0,
  "INTERNATIONAL" = 1,
  "NATIONAL" = 2,
  "RFC3966" = 3,
}

export { IntlTelFormatEnum };
